// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { ParentProductIdContext } from "@insite/client-framework/Components/ParentProductContext";
import {
    HasProductContext,
    ProductContext,
    ProductContextModel,
} from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getComputedVariantProduct,
    getProductState,
    getProductStateByPath,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import displayProduct from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const queryString = location.search;
    const queryParams = parseQueryString<{ productPath: string; productId: string }>(queryString.replace("?", ""));
    const productPath = queryParams.productPath;
    const productState = getProductStateByPath(state, productPath);
    const catalogPageState = getCatalogPageStateByPath(state, productPath);
    const variantProductState = getProductState(state, state.pages.productDetails.selectedProductId);
    const computedVariantProduct = getComputedVariantProduct(productState, variantProductState);
    const settingsCollection = getSettingsCollection(state);

    return {
        productState: computedVariantProduct,
        variantProductState,
        catalogPageState,
        parentProductState: productState,
        productInfo:
            computedVariantProduct.value && state.pages.productDetails.productInfosById
                ? state.pages.productDetails.productInfosById[computedVariantProduct.value.id]
                : undefined,
        productPath,
        queryString,
        lastProductPath: state.pages.productDetails.lastProductPath,
        location,
        searchPath: settingsCollection.searchSettings.searchPath,
        selectedProductId: state.pages.productDetails.selectedProductId,
        isProductLoading: state.pages.productDetails.isProductLoading,
    };
};

const mapDispatchToProps = {
    displayProduct,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

interface RecommandeProductRequestStyles {
    page?: MobiusPageProps;
    centeringWrapper?: InjectableCss;
}

const recommandeProductRequestStyles: RecommandeProductRequestStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            height: ${pxToRem(300)};
            justify-content: center;
            align-items: center;
        `,
    },
};

const CenteringWrapper = styled.div<InjectableCss>`
    ${({ css }) => css}
`;

const styles = recommandeProductRequestStyles;

const AlternatePackagingPage = ({
    id,
    productState,
    productInfo,
    productPath,
    lastProductPath,
    isProductLoading,
    searchPath,
    displayProduct,
}: Props) => {
    if (!productPath || productState?.value?.id === productPath) {
        return (
            <CenteringWrapper {...styles.centeringWrapper}>
                <Typography>{siteMessage("ProductAlternatePackagingPage_NoProductFound")}</Typography>
            </CenteringWrapper>
        );
    }

    useEffect(() => {
        if (
            productPath.toLowerCase() === lastProductPath?.toLowerCase() ||
            productPath.toLowerCase() === `/${searchPath.toLowerCase()}`
        ) {
            return;
        }

        if (isProductLoading) {
            return;
        }

        displayProduct({ path: productPath });
    }, [productPath, isProductLoading]);

    if (!productState.value || productState.isLoading || !productInfo) {
        return <Loader height={300} />;
    }

    const productContext: ProductContextModel = {
        product: productState.value.id === productPath ? ({} as ProductModel) : productState.value,
        productInfo,
    };

    return (
        <Page data-test-selector="productAlternatePackagingPage" {...styles.page}>
            <ProductContext.Provider value={productContext}>
                <ParentProductIdContext.Provider value={productState?.value?.id}>
                    <Zone contentId={id} zoneName="Content" />
                </ParentProductIdContext.Provider>
            </ProductContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AlternatePackagingPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
